import gql from "graphql-tag";

export const LOGIN = gql`
  query login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      accessToken
      sessionPeriod
      accessTokenPeriod
      contractCode
      currentUser {
        _id
        email
        phone
        ldapUser
        employee
        lastPasswordChange
        validFrom
        validTo
        twoFactorEnabled
        twoFactorEnabledAt
        twoFactorSecret
        twoFactorFailedCode
        twoFactorType
        twoFactorTempCodeAt
      }
      isTemporaryPassword
      requires2faVerification
    }
  }
`;
